import { createSlice } from "@reduxjs/toolkit";

const initialMyAbsenteeismsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const myAbsenteeismSlice = createSlice({
  name: "myAbsenteeisms",
  initialState: initialMyAbsenteeismsState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getAbsenteeisms
    absenteeismsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getList
    listFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.courses = entity.courses;
      state.teachers = entity.teachers;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanMyAbsenteeismsState
    myAbsenteeismsStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
    }
  }
});